import React from 'react';
import { List, Datagrid, FunctionField, TextField, NumberField, Edit, SimpleForm, NumberInput, Labeled, required } from 'react-admin';

import { DEAL_TYPES } from '../../Services/partners';

// Taux par DÉFAUT, une ligne par type d'affaire : `leads` (apport d'affaire) et `partner`.
//
// C'était une grille `programme × niveau` (6 lignes) résolue depuis le PARTENAIRE. Ces deux
// notions ont disparu — c'est l'affaire qui porte son type et son taux.
//
// ⚠️ Ce taux ne fait que PRÉ-REMPLIR une affaire à sa création. L'éditer ici ne retarife
// PAS les affaires en cours : leurs termes sont figés, volontairement.
//
// SEUL LE TAUX EST ÉDITABLE. Le slug est la CLÉ lue par api-partners ET par le webhook
// d'api-billing pour résoudre le taux d'une nouvelle affaire ; le rendre modifiable ferait
// naître les affaires à 0 %, sans aucune erreur visible (0 est une valeur légitime =
// affaire non commissionnée). Le nombre de lignes ne s'édite pas non plus : ce sont les
// deux seuls modes de commissionnement.

// #region typeName — libellé lisible d'un slug
// Le nom n'est PAS stocké : il vit dans DEAL_TYPES, partagé avec le dialogue
// d'association. Une colonne `name` en base serait un levier débranché — les libellés vus
// par les partenaires sont rendus côté ui-partners, ils ne liraient pas cette valeur.
const typeName = (slug?: string) => DEAL_TYPES.find((t) => t.id === slug)?.name || slug || '—';
// #endregion

// #region CommissionRateList
export const CommissionRateList: React.FC = (props: any) => (
	<List {...props} pagination={false} exporter={false}>
		<Datagrid rowClick="edit">
			<FunctionField label="Name" render={(r: any) => typeName(r?.commissionType)} />
			<TextField source="commissionType" label="Slug" />
			<NumberField source="rate" label="Taux %" />
		</Datagrid>
	</List>
);
// #endregion

// #region CommissionRateEdit
// Name et Slug sont des CHAMPS D'AFFICHAGE (Labeled + FunctionField), pas des inputs
// désactivés : « Name » n'existe pas dans l'enregistrement, et un input porterait une
// valeur que le formulaire pourrait tenter de renvoyer. L'API n'accepte de toute façon que
// `rate` — les deux protections se répondent.
export const CommissionRateEdit: React.FC = (props: any) => (
	<Edit {...props}>
		<SimpleForm>
			<Labeled label="Name">
				<FunctionField render={(r: any) => typeName(r?.commissionType)} />
			</Labeled>
			<Labeled label="Slug">
				<TextField source="commissionType" />
			</Labeled>
			<NumberInput source="rate" label="Taux (%)" validate={required()} />
		</SimpleForm>
	</Edit>
);
// #endregion
